import React, { useMemo, useCallback } from 'react';
import { makeStyles, createStyles } from '@mui/styles';
import { Box } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

import { AssetKey, IAsset } from 'api/catalog/models';
import myUnfiLogo from 'assets/images/logo-my-unfi.png';

import messages from '../messages';

export const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      position: 'absolute',
      top: 0,
      right: 0,
      display: 'flex',
    },
    primaryTag: {
      backgroundColor: '#0f3d61',
      color: 'white',
      borderRight: '1px solid white',
    },
    secondaryTag: {
      backgroundColor: 'white',
      color: '#0f3d61',
      border: '1px solid #0f3d61',
    },
    tag: {
      padding: '0px 6px',
      fontSize: '.75rem',
      userSelect: 'none',
      height: '30px',
      display: 'flex',
      alignItems: 'center',
    },
    lastTag: {
      borderTopRightRadius: '15px',
    },
    firstTag: {
      borderBottomLeftRadius: '15px',
    },
    image: {
      maxHeight: '15px',
    },
  })
);

interface IProps {
  asset: IAsset;
}

const ImageTags = ({ asset }: IProps) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  const tags = useMemo(() => {
    const ret: AssetKey[] = [];
    if (asset.isMainImage) {
      ret.push('isMainImage');
    }
    if (asset.isVisibleOnMyUnfi) {
      ret.push('isVisibleOnMyUnfi');
    }
    return ret;
  }, [asset.isMainImage, asset.isVisibleOnMyUnfi]);

  const getRenderedValue = useCallback(
    (key: AssetKey, index: number) => {
      const tagClasses = [classes.tag];
      if (index <= 0) {
        tagClasses.push(classes.firstTag);
      }
      if (index >= tags.length - 1) {
        tagClasses.push(classes.lastTag);
      }
      // const className = tagClasses.join(' ');
      switch (key) {
        case 'isMainImage':
          return (
            <Box className={[...tagClasses, classes.primaryTag].join(' ')}>
              <FormattedMessage {...messages.mainTag} />
            </Box>
          );
        case 'isVisibleOnMyUnfi':
          return (
            <Box className={[...tagClasses, classes.secondaryTag].join(' ')}>
              <img
                className={classes.image}
                src={myUnfiLogo}
                alt={formatMessage(messages.myUnfiAlt)}
              />
            </Box>
          );
        default:
          return null;
      }
    },
    [classes, formatMessage, tags.length]
  );

  return tags.length > 0 ? (
    <Box className={classes.wrapper}>
      {tags.map((tag, index) => (
        <React.Fragment key={index}>
          {getRenderedValue(tag, index)}
        </React.Fragment>
      ))}
    </Box>
  ) : null;
};

export default ImageTags;
